<div>
  <div class="customHeaderLabel">
    {{ params.displayName }}
    <i [ngClass]="params.icon" class="grid-icon"></i>
  </div>
</div>
